import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export const TranscriptionUpload = (props) => {
  return (
    <SvgIcon
      {...props}
      style={{ fill: props.fill || "transparent" }}
      viewBox={props.viewBox || "0 0 66 64"}
      width="66px"
      height="64px"
    >
      <path
        d="M0.754883 14.7549H59.2036C62.9571 14.7549 65.9999 17.7977 65.9999 21.5512V56.8923C65.9999 60.6458 62.9571 63.6887 59.2036 63.6887H7.55124C3.79772 63.6887 0.754883 60.6458 0.754883 56.8923V14.7549Z"
        fill="#161c21"
      />
      <path
        d="M37.4552 18.8327L28.2063 8.4247C27.1745 7.2636 25.6954 6.59924 24.1421 6.59924H4.83617C2.5827 6.59924 0.756438 8.42706 0.758354 10.6805L0.765288 18.8327H37.4552Z"
        fill="#161c21"
      />
      <rect
        x="37.603"
        width="24.8108"
        height="24.8108"
        rx="2.22478"
        transform="rotate(15.4348 37.603 0)"
        fill="#7D7AFF"
      />
      <path
        d="M52.9081 11.0102C52.861 10.9402 52.7993 10.8811 52.7274 10.837C52.6554 10.793 52.5747 10.7649 52.4909 10.7548L44.8145 9.85459C44.6748 9.83791 44.5338 9.87192 44.417 9.95043C44.3002 10.0289 44.2155 10.1467 44.1782 10.2824L42.5596 16.145C42.3306 15.9427 42.0589 15.7947 41.7647 15.7122C41.3726 15.6039 40.9572 15.6143 40.571 15.7422C40.1848 15.87 39.8452 16.1095 39.5952 16.4303C39.3451 16.7511 39.1958 17.1389 39.1661 17.5446C39.1364 17.9503 39.2277 18.3557 39.4284 18.7095C39.6291 19.0633 39.9302 19.3496 40.2937 19.5323C40.6571 19.715 41.0666 19.7858 41.4703 19.7357C41.874 19.6857 42.2537 19.5171 42.5616 19.2512C42.8695 18.9853 43.0916 18.6341 43.1998 18.242L44.3946 13.9145L50.8897 14.6775L50.236 17.0452C50.007 16.8429 49.7353 16.6949 49.4411 16.6124C49.049 16.5041 48.6336 16.5146 48.2474 16.6424C47.8612 16.7702 47.5216 17.0097 47.2716 17.3305C47.0215 17.6513 46.8722 18.0391 46.8425 18.4448C46.8128 18.8505 46.9041 19.2559 47.1048 19.6097C47.3055 19.9635 47.6066 20.2499 47.9701 20.4325C48.3335 20.6152 48.743 20.686 49.1467 20.636C49.5504 20.5859 49.9301 20.4173 50.238 20.1514C50.5459 19.8856 50.768 19.5344 50.8762 19.1423L52.9875 11.4954C53.0101 11.4136 53.0147 11.3279 53.001 11.2441C52.9873 11.1604 52.9556 11.0806 52.9081 11.0102V11.0102ZM40.9827 18.5443C40.8147 18.4979 40.6642 18.4027 40.5502 18.2708C40.4363 18.1389 40.364 17.9761 40.3426 17.8031C40.3211 17.6301 40.3515 17.4546 40.4298 17.2988C40.508 17.1431 40.6308 17.014 40.7824 16.928C40.934 16.842 41.1078 16.8029 41.2816 16.8156C41.4555 16.8283 41.6217 16.8923 41.7592 16.9995C41.8967 17.1066 41.9993 17.2522 42.0541 17.4177C42.1089 17.5832 42.1134 17.7612 42.067 17.9293C42.0047 18.1546 41.8556 18.346 41.6522 18.4613C41.4489 18.5767 41.2081 18.6065 40.9827 18.5443ZM48.6591 19.4445C48.4911 19.3981 48.3406 19.303 48.2266 19.171C48.1127 19.0391 48.0404 18.8763 48.019 18.7033C47.9975 18.5303 48.0279 18.3548 48.1061 18.1991C48.1844 18.0433 48.3072 17.9142 48.4588 17.8282C48.6104 17.7422 48.7842 17.7031 48.958 17.7158C49.1319 17.7285 49.2981 17.7925 49.4356 17.8997C49.5731 18.0069 49.6757 18.1524 49.7305 18.3179C49.7853 18.4834 49.7897 18.6614 49.7433 18.8295C49.6811 19.0548 49.5319 19.2462 49.3286 19.3616C49.1253 19.4769 48.8845 19.5068 48.6591 19.4445ZM51.2072 13.5277L44.7121 12.7646L45.1813 11.0653L51.6717 11.8454L51.2072 13.5277Z"
        fill="white"
      />
      <rect
        x="0.754883"
        y="20.1919"
        width="65.245"
        height="43.4967"
        rx="6.79636"
        fill="#484C56"
      />
    </SvgIcon>
  );
};
